var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-select", {
    attrs: {
      items: _vm.params.options,
      "item-value": "id",
      "item-text": "valueRenderer",
      label: _vm.params.label,
      solo: "",
      dense: "",
      "return-object": ""
    },
    scopedSlots: _vm._u([
      {
        key: "selection",
        fn: function(ref) {
          var item = ref.item
          return [_vm._v(" " + _vm._s(item.valueRenderer) + " ")]
        }
      },
      {
        key: "item",
        fn: function(ref) {
          var item = ref.item
          return [_vm._v(" " + _vm._s(item.valueRenderer) + " ")]
        }
      }
    ]),
    model: {
      value: _vm.selectedId,
      callback: function($$v) {
        _vm.selectedId = $$v
      },
      expression: "selectedId"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }